/*
 * Busca preditiva — porta SearchFormPredictive.tsx + usePredictiveSearch.
 * Dispara em input/focus (sem debounce, como o original; requisições
 * anteriores são abortadas), busca a seção predictive-search via Section
 * Rendering e injeta o HTML pronto. Enter não navega (paridade com o
 * resetInput); o botão Search leva a /search?q=. Cmd/Ctrl-K foca o campo
 * da página /search quando presente.
 */
function initForm(form) {
  const input = form.querySelector('[data-predictive-input]');
  const results = form.parentElement.querySelector('[data-predictive-results]');
  const goButton = form.querySelector('[data-predictive-go]');
  const baseUrl = form.dataset.predictiveUrl || '/search/suggest';
  if (!input || !results) return;

  let controller = null;

  async function fetchResults() {
    const term = input.value.trim();
    if (controller) controller.abort();
    if (!term) {
      results.innerHTML = '';
      return;
    }
    controller = new AbortController();
    try {
      const url =
        `${baseUrl}?q=${encodeURIComponent(term)}` +
        `&resources[limit]=5&resources[limit_scope]=each` +
        `&section_id=predictive-search`;
      const response = await fetch(url, {signal: controller.signal});
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('.shopify-section') || doc.body;
      results.innerHTML = section.innerHTML;
    } catch (error) {
      if (error.name !== 'AbortError') results.innerHTML = '';
    }
  }

  function goToSearch() {
    const term = input.value.trim();
    window.location.href = term
      ? `/search?q=${encodeURIComponent(term)}`
      : '/search';
  }

  input.addEventListener('input', fetchResults);
  input.addEventListener('focus', fetchResults);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    input.blur();
  });
  if (goButton) goButton.addEventListener('click', goToSearch);
}

function init() {
  document.querySelectorAll('[data-predictive-form]').forEach(initForm);

  // Cmd/Ctrl-K foca o input da página de busca (porta o hook do SearchForm.tsx).
  const cmdkInput = document.querySelector('input[data-cmdk]');
  if (cmdkInput) {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'k' && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        cmdkInput.focus();
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
